export default __webpack_public_path__ + "static/media/captur-colour-2.4c596f68.jpg";